//export const API_URL = "http://localhost:8000/";
export const API_URL = "https://toronto.nustreamrealty.com/api/";

export const INFO_EMAIL = "infotoronto@nustreamrealty.com";

export const DESIGNER_EMAIL = "design@nustreamtoronto.com";

export const S3_URL = "https://torontonustream.s3.ca-central-1.amazonaws.com/";
